/** Supported UI languages (ADR-0009). Arabic is right-to-left. */
export const supportedLanguages = ["ar", "en"] as const;
export type Language = (typeof supportedLanguages)[number];
export type Direction = "rtl" | "ltr";

export const fallbackLanguage: Language = "en";

export function isLanguage(value: unknown): value is Language {
  return typeof value === "string" && (supportedLanguages as readonly string[]).includes(value);
}

export function directionOf(language: Language): Direction {
  return language === "ar" ? "rtl" : "ltr";
}

/** Sets `lang` and `dir` on the document root so CSS logical properties and UI5 follow the language. */
export function applyDocumentLanguage(language: Language, root: HTMLElement = document.documentElement): void {
  root.lang = language;
  root.dir = directionOf(language);
}
